export const MainConfig = {
  backendEndpoint: "https://studio.retorik.ai/ajadi",
  apiKey: "K2",
  apiSecret: "K2",
};
